var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8846 34.5016V20.9477C13.9249 18.2834 14.4905 15.6533 15.549 13.208C16.6075 10.7627 18.1382 8.55032 20.0532 6.69757C21.9683 4.84482 24.2302 3.38815 26.7092 2.41102C29.1883 1.43388 31.8357 0.95549 34.5 1.00325C37.1643 0.95549 39.8117 1.43388 42.2908 2.41102C44.7698 3.38815 47.0317 4.84482 48.9468 6.69757C50.8618 8.55032 52.3925 10.7627 53.451 13.208C54.5095 15.6533 55.0751 18.2834 55.1154 20.9477V34.5016M44.8077 61.558C47.5415 61.558 50.1633 60.4721 52.0963 58.5391C54.0294 56.6061 55.1154 53.9845 55.1154 51.2508V39.6552M44.8077 61.558C44.8077 63.2665 44.129 64.9051 42.9208 66.1132C41.7126 67.3213 40.074 68 38.3654 68H30.6346C28.926 68 27.2874 67.3213 26.0792 66.1132C24.871 64.9051 24.1923 63.2665 24.1923 61.558C24.1923 59.8495 24.871 58.2109 26.0792 57.0028C27.2874 55.7947 28.926 55.116 30.6346 55.116H38.3654C40.074 55.116 41.7126 55.7947 42.9208 57.0028C44.129 58.2109 44.8077 59.8495 44.8077 61.558ZM6.15385 26.7712H11.3077C11.9911 26.7712 12.6466 27.0427 13.1299 27.526C13.6131 28.0092 13.8846 28.6646 13.8846 29.348V44.8088C13.8846 45.4922 13.6131 46.1476 13.1299 46.6309C12.6466 47.1141 11.9911 47.3856 11.3077 47.3856H6.15385C4.78696 47.3856 3.47606 46.8426 2.50953 45.8762C1.54299 44.9097 1 43.5988 1 42.232V31.9248C1 30.558 1.54299 29.2472 2.50953 28.2807C3.47606 27.3142 4.78696 26.7712 6.15385 26.7712ZM62.8462 47.3856H57.6923C57.0089 47.3856 56.3534 47.1141 55.8701 46.6309C55.3869 46.1476 55.1154 45.4922 55.1154 44.8088V29.348C55.1154 28.6646 55.3869 28.0092 55.8701 27.526C56.3534 27.0427 57.0089 26.7712 57.6923 26.7712H62.8462C64.213 26.7712 65.5239 27.3142 66.4905 28.2807C67.457 29.2472 68 30.558 68 31.9248V42.232C68 43.5988 67.457 44.9097 66.4905 45.8762C65.5239 46.8426 64.213 47.3856 62.8462 47.3856Z",
    stroke: "#195442",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 73",
    opacity: 0.2,
    x: 55,
    y: 27,
    width: 13,
    height: 20,
    rx: 3,
    fill: "#195442"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 74",
    opacity: 0.2,
    x: 1,
    y: 27,
    width: 13,
    height: 20,
    rx: 3,
    fill: "#195442"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadPhoneIcon);
export default __webpack_public_path__ + "static/media/headPhone-icon.bb7378f9a6c7829e1843bef972471b64.svg";
export { ForwardRef as ReactComponent };